import React, {
  useCallback, useContext, useEffect
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage, Input,
  LifeSaverForm,
  ScreenHeader
} from '../../components';
import { useCreateOrUpdate, useFormData } from '../../hooks';

import { NewFAContext } from '.';

const formConfig = {
  fields: [
    { id: 'burial-location', fieldName: 'burial_location', type: 'text' as const, required: true },
    { id: 'funeral-home', fieldName: 'funeral_home', type: 'text' as const, required: true },
    { id: 'casket-type', fieldName: 'casket_type', type: 'text' as const, required: true },
    { id: 'burial-marker', fieldName: 'burial_marker', type: 'text' as const, required: false }
  ]
};

export function NewFABurialArrangements() {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleCreateOrUpdate } = useCreateOrUpdate('funeral_arrangements');
  const { handleData, errors } = useFormData(formConfig);

  // Seed existing data into form fields
  useEffect(() => {
    console.log('NewFABurialArrangements useEffect', funeralArrangement);
    if (funeralArrangement) {
      if (funeralArrangement.burialLocation) {
        (document.getElementById('burial-location') as HTMLInputElement).value = funeralArrangement.burialLocation;
      }
      if (funeralArrangement.funeralHome) {
        (document.getElementById('funeral-home') as HTMLInputElement).value = funeralArrangement.funeralHome;
      }
      if (funeralArrangement.casketType) {
        (document.getElementById('casket-type') as HTMLInputElement).value = funeralArrangement.casketType;
      }
      if (funeralArrangement.burialMarker) {
        (document.getElementById('burial-marker') as HTMLInputElement).value = funeralArrangement.burialMarker;
      }
    }
  }, [ funeralArrangement ]);
    
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const formData = handleData();
    
    // Validate required fields
    if (!formData.burial_location || !formData.funeral_home || !formData.casket_type) {
      return;
    }

    const payload = {
      ...formData
    };

    try {
      await handleCreateOrUpdate(funeralArrangement?.id || '', payload);
      await update();
      navigate('../ceremony-preferences');
    } catch (err) {
      console.error('Error saving burial arrangements:', err);
    }
  }, [ navigate, funeralArrangement, handleCreateOrUpdate, update, handleData ]);

  return (
    <div className="new-fa-disposition screen">
      <ScreenHeader 
        title="Burial Arrangements"
        description="Specify your burial preferences and arrangements."
        steps={6}
        step={1}
        handleBack={handleBack}
      />

      <LifeSaverForm 
        icon="location_on"
        header="Location & Services"
      >
        <Input
          id="burial-location"
          name="burial_location"
          label="Preferred Burial Site"
          placeholder="Enter burial location"
          required
        />
        <Input
          id="funeral-home"
          name="funeral_home"
          label="Funeral Home"
          placeholder="Enter funeral home"
          required
        />
      </LifeSaverForm>
      <LifeSaverForm 
        icon="event_note"
        header="Casket & Burial"
      >
        <Input
          id="casket-type"
          name="casket_type"
          label="Preferred Casket Type"
          placeholder="Enter casket type"
          required
        />
      </LifeSaverForm>
      <LifeSaverForm
        icon="deceased"
        header="Burial Marker & Memorial"
      >
        <Input
          id="burial-marker"
          name="burial_marker"
          label="Epitaph or Inscription"
          placeholder="Text you'd like on your burial marker or headstone"
        />
      </LifeSaverForm>

      <ErrorMessage message={errors[0]} />
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}

